import { useEffect, useState } from "react";
import { api, rp } from "@/api";
import { statusLabel, statusClass } from "@/components/OrderList_gen3";

export function MyOrders({ slug, store, refreshKey }) {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get(`/public/stores/${slug}/my-orders`).then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, [slug, refreshKey]);

  if (!orders) return null;
  const tunggakan = orders.filter((o) => (o.remaining || 0) > 0 || o.status !== "lunas");
  if (tunggakan.length === 0) return null;

  return (
    <div className="my-orders" data-testid="my-orders">
      <h2 className="section-heading row" style={{ padding: 0 }}>Tunggakan Saya Sebelumnya</h2>
      <div className="order-list">
        {tunggakan.slice(0, 10).map((o) => (
          <div className={`order-card ${o.status === "lunas" ? "paid" : "unpaid"}`} key={o.id} data-testid={`my-order-${o.id}`}>
            <div className="order-head">
              <div>
                <span className={`status-pill ${statusClass(o.status)}`}>{statusLabel(o.status)}</span>
                <div className="order-time">{new Date(o.created_at).toLocaleString("id-ID")}</div>
              </div>
              <span className="order-total"><strong>{rp(o.total)}</strong></span>
            </div>
            <ul className="order-items">
              {(o.vouchers || []).map((v, i) => <li key={`v${i}`}>{v.name} × {v.qty} — <strong>{rp(v.qty * v.price)}</strong></li>)}
              {(o.extras || []).map((e, i) => <li key={`e${i}`}>{e.name} — {rp(e.price)}</li>)}
            </ul>
            {o.buyer_note && <div className="muted-sm">Catatan: {o.buyer_note}</div>}
            {o.remaining > 0 && o.paid_amount > 0 && <div className="muted-sm warn-text">Sisa {rp(o.remaining)}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
